<template>
  <div class="input-container">
    <input
      v-if="showInput"
      class="input-search input"
      v-model="searchQuery"
      :placeholder="computedPlaceholder"
      :class="{ 'input-error': showError && !searchQuery }"
      @keyup.enter="handleClick"
    />
    <span class="search-icon material-icons-outlined" @click.prevent="handleClick"
      >search</span
    >
  </div>

  <select v-if="showSelect" v-model="sortOrder">
    <option value="asc">{{ $t("Filter.ascending") }}</option>
    <option value="desc">{{ $t("Filter.descending") }}</option>
  </select>
</template>

<script>
export default {
  name: "SearchAndFilter",
  props: {
    modelValue: String,
    modelValueSort: String,
    showInput: {
      type: Boolean,
      default: true,
    },
    showSelect: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: null,
    },
    nullable: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    searchQuery: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    sortOrder: {
      get() {
        return this.modelValueSort;
      },
      set(value) {
        this.$emit("update:modelValueSort", value);
      },
    },
    computedPlaceholder() {
      return this.placeholder || this.$t("List.searchByListName");
    },
    showError() {
      return this.submitAttempted && !this.searchQuery;
    },
  },
  data() {
    return {
      submitAttempted: false,
    };
  },
  methods: {
		handleClick() {
      this.submitAttempted = true;
      if (this.searchQuery || this.nullable) {
				this.$emit("submitForm");
      }
		},
  },
};
</script>

<style scoped>
.half-width {
  width: 100%;
}

.input {
  width: 100%;
  padding: 12px 20px;
  border: 1px solid #ccc;
  outline: 0;
  border-radius: 5px;
  background-color: transparent;
  font-size: 0.85rem;
  transition: all 0.5s;
}

.input:focus {
  border: 1px solid #000;
}

.input:-webkit-autofill,
.input:-webkit-autofill:hover,
.input:-webkit-autofill:focus,
.input:-webkit-autofill:active {
  -webkit-background-clip: text;
  -webkit-text-fill-color: #000;
  transition: background-color 5000s ease-in-out 0s;
}

.input-search {
  flex: 1;
  padding-right: 30px;
  background-color: var(--text-white);
}
.search-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #888;
}
.search-icon:hover {
  color: #666;
}

@media (max-width: 768px) {
  .input {
    font-size: 12px;
    padding: 10px 20px;
  }

  .search-icon{
    font-size: 18px;
  }
} 
</style>
